/* unplugin-vue-components disabled */import { render } from "./icon.vue?vue&type=template&id=db11e7ae&scoped=true"
import script from "./icon.vue?vue&type=script&lang=js"
export * from "./icon.vue?vue&type=script&lang=js"

import "./icon.vue?vue&type=style&index=0&id=db11e7ae&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db11e7ae"],['__file',"src/controls/icon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "db11e7ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('db11e7ae', __exports__)) {
    api.reload('db11e7ae', __exports__)
  }
  
  module.hot.accept("./icon.vue?vue&type=template&id=db11e7ae&scoped=true", () => {
    api.rerender('db11e7ae', render)
  })

}


export default __exports__